var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLotsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2978 2.13398C11.4498 1.68582 12.6695 2.41093 12.9433 3.58059L14.3675 3.08809C15.6626 2.64026 17 3.64025 17 5.05642V5.54248L18.4253 5.0989C19.7085 4.69954 21 5.69637 21 7.08619V16.7464C21 18.1362 19.7085 19.133 18.4253 18.7337L17 18.2901V18.7761C17 20.1923 15.6626 21.1923 14.3675 20.7445L12.9738 20.2625C12.7902 21.434 11.6691 22.2364 10.5149 21.937L4.51494 20.3809C3.6246 20.15 3.00001 19.3201 3.00001 18.3681V6.41082C3.00001 5.54595 3.51715 4.7718 4.29776 4.46812L10.2978 2.13398ZM15 16.9199C14.9997 16.9041 14.9996 16.8883 15 16.8725V6.96008C14.9996 6.94423 14.9997 6.92842 15 6.91266V5.05642L13.3162 5.63866C13.2114 5.67493 13.1048 5.69216 13 5.69218V15.1322V18.1404C13.1048 18.1404 13.2114 18.1576 13.3162 18.1939L15 18.7761V16.9199ZM17 7.70863V16.1239L19 16.7464V7.08619L17 7.70863ZM11 4.07667L5.00001 6.41082V18.3681L11 19.9242V15.1322V4.07667Z",
    fill: "#B1ADA2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLotsIcon);
export default __webpack_public_path__ + "static/media/lotsIcon.0ee5b02767e41779888d975f32cbe33d.svg";
export { ForwardRef as ReactComponent };